import {Application} from 'pixi.js';

import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
} from './GameConst';

import { sceneManager } from './SceneManager';
import { TitleScene } from './scenes/TitleScene';
// import { BattleScene } from './scenes/BattleScene';



const app = new Application({
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
    backgroundColor: 0x1099bb,
});
app.view.style.position = 'absolute';
app.view.style.margin = 'auto';
app.view.style.top = '0px';
app.view.style.left = '0px';
app.view.style.bottom = '0px';
app.view.style.right = '0px';
app.view.style.maxWidth = '100%';
app.view.style.maxHeight = '100%';
document.body.appendChild(app.view);

async function Start(){
    await sceneManager.Init(app);
    sceneManager.LoadScene(TitleScene);
    // sceneManager.LoadScene(BattleScene);
}
Start();
